import controller from './activity.controller';
import template from './activity.html';

export default { controller, template };



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/widgets/activity/activity.component.js